class InstaStories extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector(".insta-stories__modal");
    this.slider = this.querySelector(".insta-stories__slider");
    this.stories = Array.from(this.querySelectorAll(".insta-story"));
    this.openBtns = this.querySelectorAll(".insta-story-open-btn");
    this.closeBtns = this.querySelectorAll(".insta-stories__close-button");
    this.pauseResumeBtns = this.querySelectorAll(".insta-story__pause-resume-btn");
    this.volumeBtns = this.querySelectorAll(".insta-story__volume-btn");
    this.prevTapBtns = this.querySelectorAll(".insta-story__prev");
    this.nextTapBtns = this.querySelectorAll(".insta-story__next");
    this.modalPrevBtn = this.querySelector(".insta-stories__modal-arrow--prev");
    this.modalNextBtn = this.querySelector(".insta-stories__modal-arrow--next");

    this.activeIndex = 0;
    this.lastIndex = this.stories.length - 1;
    this.modalOpen = false;
    this.isPaused = false;
    this.isMuted = true;
    this.autoplayTimeout = null;

    this.touchStartX = 0;
    this.touchEndX = 0;

    this.init();
  }

  init() {
    this.openBtns.forEach((btn, index) => {
      btn.addEventListener("click", () => this.openModal(index));
    });

    this.closeBtns.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeModal();
      });
    });

    this.prevTapBtns.forEach((btn) => {
      btn.addEventListener("click", () => this.storyPrevBtnClick());
    });

    this.nextTapBtns.forEach((btn) => {
      btn.addEventListener("click", () => this.storyNextBtnClick());
    });

    if (this.modalPrevBtn) {
      this.modalPrevBtn.addEventListener("click", () => this.storyPrevBtnClick());
    }

    if (this.modalNextBtn) {
      this.modalNextBtn.addEventListener("click", () => this.storyNextBtnClick());
    }

this.pauseResumeBtns.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.togglePauseResume();
  });
});    

this.volumeBtns.forEach((btn) => {
  btn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.toggleIsMuted();
  });
});

    document.addEventListener("keydown", (e) => {
      if (!this.modalOpen) return;
      if (e.key === "Escape") this.closeModal();
      if (e.key === "ArrowRight") this.storyNextBtnClick();
      if (e.key === "ArrowLeft") this.storyPrevBtnClick();
    });

    this.slider.addEventListener("touchstart", (e) => {
      this.touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    this.slider.addEventListener("touchend", (e) => {
      this.touchEndX = e.changedTouches[0].clientX;
      this.handleSwipe();
    }, { passive: true });
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) < 40) return;

    if (diff > 0) {
      this.storyNextBtnClick();
    } else {
      this.storyPrevBtnClick();
    }
  }

  openModal(index) {
    this.modalOpen = true;
    this.modal.setAttribute("data-open", "true");
    document.body.style.overflow = "hidden";
    this.changeActiveStory(index);
  }

  closeModal() {
    this.modalOpen = false;
    this.modal.setAttribute("data-open", "false");
    document.body.style.overflow = "";
    clearTimeout(this.autoplayTimeout);
    this.pauseAllVideos();
    this.isPaused = false;
  }

  changeActiveStory(index) {
    if (index < 0) return;
    if (index > this.lastIndex) {
      this.closeModal();
      return;
    }

    clearTimeout(this.autoplayTimeout);
    this.pauseAllVideos();

    this.activeIndex = index;
    this.activeStory = this.stories[this.activeIndex];

    this.stories.forEach((story) => {
      story.classList.remove("insta-story--active");

      story.querySelectorAll(".insta-story__progress-item").forEach((item) => {
        item.classList.remove("insta-story__progress-item--active", "insta-story__progress-item--completed");
      });

      story.querySelectorAll(".insta-story__progress-bar").forEach((bar) => {
        bar.style.animation = "none";
        bar.offsetHeight;
        bar.style.animation = "";
        bar.style.animationPlayState = "running";
      });
    });

    this.activeStory.classList.add("insta-story--active");

    if (window.innerWidth > 768) {
      const offset = this.activeIndex * -1;
      this.slider.style.transform = `translateX(calc(var(--story-width) * ${offset}))`;
    } else {
      const offset = this.activeIndex * -100;
      this.slider.style.transform = `translateX(${offset}vw)`;
    }

    this.isPaused = false;
    this.updatePauseIcons();
    this.updateActiveMedia();
    this.updateProgressBars();
    this.updateVolumeState();
    this.startAutoplay();
  }

updateActiveMedia() {
  this.stories.forEach((story, storyIndex) => {
    const media = story.querySelector(".insta-story__media");
    if (!media) return;

    media.style.display = "block";

    const video = media.querySelector("video");
    if (video) {
      if (storyIndex === this.activeIndex) {
        video.muted = this.isMuted;
        video.currentTime = 0;
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
        video.muted = true;
      }
    }
  });
}

  updateProgressBars() {
    if (!this.activeStory) return;

    const progressItem = this.activeStory.querySelector(".insta-story__progress-item");
    if (!progressItem) return;

    progressItem.classList.add("insta-story__progress-item--active");

    const progressBar = progressItem.querySelector(".insta-story__progress-bar");
    if (progressBar) {
      progressBar.style.animation = "none";
      progressBar.offsetHeight;
      progressBar.style.animation = "";
      progressBar.style.animationPlayState = "running";
    }
  }

  getActiveDuration() {
    if (!this.activeStory) return 5000;
    const media = this.activeStory.querySelector(".insta-story__media");
    if (!media) return 5000;

    const duration = parseInt(media.dataset.duration, 10);
    return (isNaN(duration) ? 5 : duration) * 1000;
  }

  startAutoplay() {
    clearTimeout(this.autoplayTimeout);
    if (this.isPaused) return;

    this.autoplayTimeout = setTimeout(() => {
      this.storyNextBtnClick();
    }, this.getActiveDuration());
  }

  storyNextBtnClick() {
    this.changeActiveStory(this.activeIndex + 1);
  }

  storyPrevBtnClick() {
    this.changeActiveStory(this.activeIndex - 1);
  }

  togglePauseResume() {
    if (!this.activeStory) return;

    this.isPaused = !this.isPaused;

    const activeVideo = this.activeStory.querySelector(".insta-story__media video");
    const activeProgressBar = this.activeStory.querySelector(".insta-story__progress-bar");

    if (this.isPaused) {
      clearTimeout(this.autoplayTimeout);
      if (activeVideo) activeVideo.pause();
      if (activeProgressBar) activeProgressBar.style.animationPlayState = "paused";
    } else {
      if (activeVideo) activeVideo.play().catch(() => {});
      if (activeProgressBar) activeProgressBar.style.animationPlayState = "running";
      this.startAutoplay();
    }

    this.updatePauseIcons();
  }

  updatePauseIcons() {
    this.pauseResumeBtns.forEach((btn, index) => {
      const story = this.stories[index];
      const pauseIcon = btn.querySelector(".insta-story__pause-icon");
      const playIcon = btn.querySelector(".insta-story__play-icon");

      if (!story.classList.contains("insta-story--active")) {
        if (pauseIcon) pauseIcon.style.display = "inline";
        if (playIcon) playIcon.style.display = "none";
        btn.setAttribute("data-paused", "false");
        return;
      }

      btn.setAttribute("data-paused", this.isPaused ? "true" : "false");

      if (pauseIcon) pauseIcon.style.display = this.isPaused ? "none" : "inline";
      if (playIcon) playIcon.style.display = this.isPaused ? "inline" : "none";
    });
  }
 
  //toggleIsMuted() {
    //if (!this.activeStory) return;

    //const hasVideo = !!this.activeStory.querySelector(".insta-story__media video");
    //if (!hasVideo) return;

    //this.isMuted = !this.isMuted;
    //this.updateVolumeState();
  //}

toggleIsMuted() {
  if (!this.activeStory) return;

  const hasVideo = !!this.activeStory.querySelector(".insta-story__media video");

  if (!hasVideo) {
    return;
  }

  this.isMuted = !this.isMuted;
  this.updateVolumeState();
}

  updateVolumeState() {
    this.volumeBtns.forEach((btn, index) => {
      const story = this.stories[index];
      const mutedIcon = btn.querySelector(".insta-story__volume-icon--muted");
      const unmutedIcon = btn.querySelector(".insta-story__volume-icon--unmuted");
      const video = story.querySelector(".insta-story__media video");
      const isActive = story.classList.contains("insta-story--active");

      if (!video) {
        btn.classList.add("is-disabled");
        if (mutedIcon) mutedIcon.style.display = "inline-flex";
        if (unmutedIcon) unmutedIcon.style.display = "none";
        return;
      }

      btn.classList.remove("is-disabled");

      if (isActive) {
        video.muted = this.isMuted;
        if (mutedIcon) mutedIcon.style.display = this.isMuted ? "inline-flex" : "none";
        if (unmutedIcon) unmutedIcon.style.display = this.isMuted ? "none" : "inline-flex";
      } else {
        video.muted = true;
        if (mutedIcon) mutedIcon.style.display = "inline-flex";
        if (unmutedIcon) unmutedIcon.style.display = "none";
      }
    });
  }

  pauseAllVideos() {
    this.querySelectorAll("video").forEach((video) => {
      video.pause();
      video.currentTime = 0;
      video.muted = true;
    });
  }
}

if (!customElements.get("insta-stories")) {
  customElements.define("insta-stories", InstaStories);
}

//ARRASTRAR CARRUSEL EN COMPUTADOR

document.querySelectorAll(".insta-stories__open-buttons-container").forEach((container) => {
  let isDown = false;
  let startX = 0;
  let scrollLeft = 0;

  container.addEventListener("mousedown", (e) => {
    isDown = true;
    container.classList.add("is-dragging");
    startX = e.pageX - container.offsetLeft;
    scrollLeft = container.scrollLeft;
  });

  container.addEventListener("mouseleave", () => {
    isDown = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mouseup", () => {
    isDown = false;
    container.classList.remove("is-dragging");
  });

  container.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - container.offsetLeft;
    const walk = (x - startX) * 1.2;
    container.scrollLeft = scrollLeft - walk;
  });
});